import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FoodvendorapiService } from './foodvendorapi.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrlVegitation}api/`;

@Injectable({
  providedIn: 'root'
})
export class AddfoodvendorService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  excelContent: any;

  constructor(private apiService: FoodvendorapiService, private http: HttpClient) {

  }

  addFoodCourtVendor(body?: any): Observable<any> {
    return this.apiService.post(APIs.createFoodCourtVendor, body).pipe(map(response => {
      return response;
    }));
  }

  updateFoodCourtVendor(body?: any): Observable<any> {
    return this.apiService.post(APIs.updateFoodCourtVendor, body).pipe(map(response => {
      return response;
    }));
  }
}